__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@portal/configuration";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@distribusion/portal-lib/auth", "0.30.0", () => (Promise.all([__webpack_require__.e(661), __webpack_require__.e(17), __webpack_require__.e(208), __webpack_require__.e(687), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(27017))))));
			register("@distribusion/portal-lib/components", "0.30.0", () => (Promise.all([__webpack_require__.e(475), __webpack_require__.e(208), __webpack_require__.e(594), __webpack_require__.e(376), __webpack_require__.e(702), __webpack_require__.e(22)]).then(() => (() => (__webpack_require__(61475))))));
			register("@distribusion/portal-lib/i18n", "0.30.0", () => (Promise.all([__webpack_require__.e(515), __webpack_require__.e(594)]).then(() => (() => (__webpack_require__(24515))))));
			register("@distribusion/portal-lib/query-client", "0.30.0", () => (Promise.all([__webpack_require__.e(687), __webpack_require__.e(507)]).then(() => (() => (__webpack_require__(38507))))));
			register("@distribusion/portal-lib/translation", "0.30.0", () => (Promise.all([__webpack_require__.e(560), __webpack_require__.e(594)]).then(() => (() => (__webpack_require__(2560))))));
			register("@distribusion/portal-lib/user-settings", "0.30.0", () => (Promise.all([__webpack_require__.e(208), __webpack_require__.e(772)]).then(() => (() => (__webpack_require__(26772))))));
			register("i18next", "24.2.3", () => (__webpack_require__.e(79).then(() => (() => (__webpack_require__(63079))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(143), __webpack_require__.e(208)]).then(() => (() => (__webpack_require__(8143))))));
			register("react-i18next", "12.3.1", () => (Promise.all([__webpack_require__.e(248), __webpack_require__.e(208)]).then(() => (() => (__webpack_require__(79248))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(457), __webpack_require__.e(208), __webpack_require__.e(702)]).then(() => (() => (__webpack_require__(2457))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(988), __webpack_require__.e(208)]).then(() => (() => (__webpack_require__(94988))))));
			register("react", "18.3.1", () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};